import { Icon } from '@atom/mui';

import { FilterForm } from '../AssetWorkOrdersFilterPanel';

import TeamAssignedToFilter from './TeamAssignedToFilters';
import TeamCommonUserFilter from './TeamCommonUserFilter';

import classes from './../assetWorkOrdersFilterPanel.module.css';

interface Props {
  areFiltersDisabled: boolean;
  teamAssignedToGroupIds: string[];
  teamAssignedToUserIds: string[];
  teamCompletedByIds: string[];
  teamCreatedByIds: string[];
  updateFilterFormData: (field: keyof FilterForm, updatedVal: any) => void;
}

const TeamFiltersSection = ({
  areFiltersDisabled,
  teamAssignedToGroupIds,
  teamAssignedToUserIds,
  teamCompletedByIds,
  teamCreatedByIds,
  updateFilterFormData,
}: Props) => {
  return (
    <div className={classes.filterSection}>
      <div className={classes.filterSectionHeader}>
        <Icon>people</Icon>
        Team
      </div>
      <div className={classes.filterContainer}>
        <TeamAssignedToFilter
          areFiltersDisabled={areFiltersDisabled}
          teamAssignedToGroupIds={teamAssignedToGroupIds}
          teamAssignedToUserIds={teamAssignedToUserIds}
          updateAssignedToGroupIds={updatedGroupIds =>
            updateFilterFormData('teamAssignedToGroupIds', updatedGroupIds)
          }
          updateAssignedToUserIds={updatedUserIds =>
            updateFilterFormData('teamAssignedToUserIds', updatedUserIds)
          }
        />
      </div>
      <div className={classes.filterContainer}>
        <TeamCommonUserFilter
          areFiltersDisabled={areFiltersDisabled}
          placeholder="Search for user"
          label="Completed By"
          usersFilter={teamCompletedByIds}
          updateUsersFilter={updatedFilter =>
            updateFilterFormData('teamCompletedByIds', updatedFilter)
          }
        />
      </div>
      <div className={classes.filterContainer}>
        <TeamCommonUserFilter
          areFiltersDisabled={areFiltersDisabled}
          placeholder="Search for user"
          label="Created By"
          usersFilter={teamCreatedByIds}
          updateUsersFilter={updatedFilter =>
            updateFilterFormData('teamCreatedByIds', updatedFilter)
          }
        />
      </div>
    </div>
  );
};

export default TeamFiltersSection;
